import React from 'react';
import Container from './Container.js';
import './App.scss';
import './AppDesktop.scss';

function App() {

  return (
    <div className="App">
      {<Container/>}
    </div>
  );
}

//switch -> 4-5 cases, each correpsonding to a page. toggle the caseNum with nav buttons

//Set up CSS grid (x)
//Finish laying out mobile homepage (X)
//Finish mobile homepage animations (x)
//Finish web layout
//Finish web animations
//Finish design portfolio page - mobile
//Finish design portfolio page - homepage
//Finish individual case study page template
//SPA layout/logic


export default App;
